import { jsx } from "react/jsx-runtime";
import { useClassName } from "@contember/react-utils";
import { deprecate, fallback, dataAttribute } from "@contember/utilities";
import { memo } from "react";
const Divider = memo(({ className, componentClassName = "divider", gap = true, ...rest }) => {
  deprecate("1.3.0", gap === "none", '`gap="none"`', "`gap={false}`");
  gap = fallback(gap, gap === "none", false);
  deprecate("1.3.0", gap === "small", '`gap="small"`', '`gap="gap"`');
  gap = fallback(gap, gap === "small", "gap");
  deprecate("1.3.0", gap === "xlarge", '`gap="xlarge"`', '`gap="larger"`');
  gap = fallback(gap, gap === "xlarge", "larger");
  deprecate("1.3.0", gap === "default", '`gap="default"`', "omit the `gap` prop");
  gap = fallback(gap, gap === "default", true);
  return /* @__PURE__ */ jsx(
    "div",
    {
      "data-gap": dataAttribute(gap),
      className: useClassName(componentClassName, className),
      ...rest
    }
  );
});
Divider.displayName = "Interface.Divider";
export {
  Divider
};
//# sourceMappingURL=Divider.js.map
